import {
    KEYWORD_OUTER_CHILDREN,
    LayoutTopPaneType,
    LayoutPaneSubtype,
    LayoutSidebarPaneType,
} from '../types-and-constants/LayoutPaneTypesAndConstants'

export const getPaneTypeClassModifier = (paneType: LayoutPaneSubtype): string | null => {
    if (paneType === LayoutSidebarPaneType.SIDEBAR_STICKY_LEFT) return 'sticky-left'
    if (paneType === LayoutSidebarPaneType.SIDEBAR_STICKY_RIGHT) return 'sticky-right'
    if (paneType === LayoutSidebarPaneType.SIDEBAR_FIXED) return KEYWORD_OUTER_CHILDREN
    if (paneType === LayoutTopPaneType.TOP_PANE_FIXED) return KEYWORD_OUTER_CHILDREN
    return null
}
